import Axios from 'axios';

export const getAddressByCep = (cep) => Axios.get(`https://viacep.com.br/ws/${cep}/json/`);
